// Constitution and Organic Laws Data - 4th Republic of Côte d'Ivoire
// DO NOT MODIFY THIS TEXT - Official legal content

export const constitutionData = {
  title: "PROJET DE LOI PORTANT CONSTITUTION DE LA 4ᵉ RÉPUBLIQUE DE CÔTE D'IVOIRE",
  subtitle: "Titre : UNE NATION, UN AVENIR",
  
  preamble: {
    id: "preambule",
    title: "Préambule",
    content: `Nous, peuple souverain de Côte d'Ivoire,
- Résolus à rétablir la paix, la justice et la prospérité dans notre nation,
- Convaincus de l'importance de la démocratie, de l'État de droit, de la solidarité et de la décentralisation,
- Engagés à garantir un développement harmonieux et équitable à travers une gouvernance moderne, participative et transparente,

Adoptons la présente Constitution de la 4ᵉ République de Côte d'Ivoire.`
  },
  
  titles: [
    {
      id: "titre-1",
      number: "I",
      title: "Des Dispositions Générales",
      chapters: [],
      articles: [
        { number: 1, id: "article-1", text: "La Côte d'Ivoire est une République unie, démocratique, décentralisée, sociale et respectueuse des droits fondamentaux." },
        { number: 2, id: "article-2", text: "La souveraineté nationale appartient au peuple ivoirien, qui l'exerce par ses représentants élus et par référendum. Aucune partie du peuple, aucune organisation, aucun individu ne peut s'en attribuer l'exercice." },
        { number: 3, id: "article-3", text: "La séparation des pouvoirs exécutif, législatif et judiciaire est garantie par la présente Constitution." },
        { number: 4, id: "article-4", text: "Les symboles de la République sont le drapeau national, l'hymne national et les armoiries." }
      ]
    },
    {
      id: "titre-2",
      number: "II",
      title: "Des Droits et Libertés Fondamentaux",
      chapters: [
        {
          id: "titre-2-chapitre-1",
          number: "I",
          title: "Droits individuels et collectifs",
          articles: [
            { number: 5, id: "article-5", text: "L'État garantit la liberté d'expression, de presse, de réunion, d'association et de manifestation." },
            { number: 6, id: "article-6", text: "Les restrictions aux libertés publiques ne peuvent être décidées que par une loi organique et limitées à des cas de sécurité nationale, de protection de l'ordre public ou de santé publique." },
            { number: 7, id: "article-7", text: "Tout citoyen affecté par une restriction peut saisir directement le Conseil constitutionnel via un recours accéléré." }
          ]
        },
        {
          id: "titre-2-chapitre-2",
          number: "II",
          title: "Droits économiques et sociaux",
          articles: [
            { number: 8, id: "article-8", text: "Tout citoyen a droit à l'éducation, à la santé, au logement, à l'emploi et à l'accès aux infrastructures essentielles." },
            { number: 9, id: "article-9", text: "L'éducation publique est gratuite et obligatoire jusqu'à l'âge de 16 ans." },
            { number: 10, id: "article-10", text: "L'État garantit un accès équitable aux services de santé et veille à la réduction des inégalités régionales en matière de soins." }
          ]
        }
      ],
      articles: []
    },
    {
      id: "titre-3",
      number: "III",
      title: "De l'Organisation des Pouvoirs",
      chapters: [
        {
          id: "titre-3-chapitre-1",
          number: "I",
          title: "Le pouvoir exécutif",
          articles: [
            { number: 11, id: "article-11", text: "Le Président de la République est le Chef de l'État. Il est élu au suffrage universel direct, conjointement avec un Vice-Président, pour un mandat de cinq ans. Le mandat du Président est renouvelable sans limitation." },
            { number: "11 bis", id: "article-11-bis", text: "L'élection présidentielle se fait au scrutin de liste : chaque candidature comprend un binôme composé d'un candidat à la présidence et d'un candidat à la vice-présidence." },
            { number: 12, id: "article-12", text: "Le Président exerce les fonctions de garant de la Nation et de la Constitution. Il conduit la politique étrangère, signe les traités internationaux et représente l'État à l'extérieur. Il définit les grandes orientations stratégiques au niveau national." },
            { number: 13, id: "article-13", text: "Le Vice-Président de la République est élu sur le même ticket que le Président. Il jouit de pouvoirs publics élargis et a la responsabilité directe de la gestion des administrations territoriales, du suivi des collectivités locales et de la mise en œuvre des politiques de décentralisation." },
            { number: 14, id: "article-14", text: "Le Vice-Président supplée le Président en cas de vacance, d'incapacité ou de décès." }
          ]
        },
        {
          id: "titre-3-chapitre-2",
          number: "II",
          title: "Le pouvoir législatif",
          articles: [
            { number: 15, id: "article-15", text: "Le Parlement est composé de deux chambres : l'Assemblée nationale et le Sénat." },
            { number: 16, id: "article-16", text: "L'Assemblée nationale est élue au suffrage universel direct." },
            { number: 17, id: "article-17", text: "Le Sénat est composé de représentants élus par les assemblées provinciales." },
            { number: 18, id: "article-18", text: "Le Parlement vote les lois, contrôle l'action du gouvernement et peut ouvrir des commissions d'enquête." },
            { number: 19, id: "article-19", text: "L'opposition parlementaire dispose de droits spécifiques : représentation proportionnelle dans les commissions, droit à l'initiative prioritaire de lois." }
          ]
        }
      ],
      articles: []
    },
    {
      id: "titre-4",
      number: "IV",
      title: "De la Décentralisation et des Collectivités Territoriales",
      chapters: [],
      articles: [
        { number: 20, id: "article-20", text: "La Côte d'Ivoire est organisée en collectivités territoriales décentralisées : provinces, départements, communes et districts." },
        { number: 21, id: "article-21", text: "Les provinces sont dirigées par un gouverneur élu et une assemblée provinciale." },
        { number: 22, id: "article-22", text: "Les départements sont des subdivisions administratives des provinces, dirigés par des préfets." },
        { number: 23, id: "article-23", text: "Les communes sont administrées par un maire élu et un conseil municipal." },
        { number: 24, id: "article-24", text: "Les districts regroupent plusieurs communes pour gérer les politiques métropolitaines." },
        { number: 25, id: "article-25", text: "Un fonds de péréquation garantit l'équité financière entre collectivités territoriales." }
      ]
    },
    {
      id: "titre-5",
      number: "V",
      title: "De la Démocratie Participative",
      chapters: [],
      articles: [
        { number: 26, id: "article-26", text: "Le référendum d'initiative populaire peut être déclenché par une pétition représentant au moins 10 % des électeurs inscrits." },
        { number: 27, id: "article-27", text: "Les pétitions citoyennes sont reconnues et doivent être examinées par le Parlement dans un délai de trois mois." },
        { number: 28, id: "article-28", text: "Un panel citoyen tiré au sort, renouvelé tous les deux ans, évalue l'action gouvernementale et publie un rapport annuel." }
      ]
    },
    {
      id: "titre-6",
      number: "VI",
      title: "De la Transparence Électorale",
      chapters: [],
      articles: [
        { number: 29, id: "article-29", text: "La Commission Électorale Indépendante (CEI) organise et supervise les élections." },
        { number: 30, id: "article-30", text: "Ses membres sont désignés par des institutions indépendantes." },
        { number: 31, id: "article-31", text: "La CEI est tenue de publier ses rapports d'activité et ses audits financiers." }
      ]
    },
    {
      id: "titre-7",
      number: "VII",
      title: "Du Pouvoir Judiciaire",
      chapters: [],
      articles: [
        { number: 32, id: "article-32", text: "Le pouvoir judiciaire est indépendant." },
        { number: 33, id: "article-33", text: "Le Conseil supérieur de la magistrature supervise la carrière des juges et protège leur indépendance." },
        { number: 34, id: "article-34", text: "Le Conseil constitutionnel est composé de membres désignés par le Président, le Parlement et le Conseil supérieur de la magistrature." }
      ]
    },
    {
      id: "titre-8",
      number: "VIII",
      title: "De l'Éducation et de la Mémoire Nationale",
      chapters: [],
      articles: [
        { number: 35, id: "article-35", text: "L'éducation est un droit fondamental." },
        { number: 36, id: "article-36", text: "Le calendrier scolaire est adapté aux deux saisons du pays." },
        { number: 37, id: "article-37", text: "Un réseau de « maisons des opportunités » est créé pour offrir un accès à la formation, aux technologies et à l'entrepreneuriat." },
        { number: 38, id: "article-38", text: "L'État veille à la préservation et à la transmission du patrimoine culturel ivoirien." }
      ]
    },
    {
      id: "titre-9",
      number: "IX",
      title: "Du Contrôle des Finances Publiques",
      chapters: [],
      articles: [
        { number: 39, id: "article-39", text: "La Cour des comptes contrôle la gestion des finances publiques. Ses rapports sont publiés." },
        { number: 40, id: "article-40", text: "Tout citoyen justifiant d'un intérêt direct peut saisir la Cour des comptes." }
      ]
    },
    {
      id: "titre-10",
      number: "X",
      title: "Des Institutions Consultatives",
      chapters: [],
      articles: [
        { number: 41, id: "article-41", text: "Le Conseil économique, social, environnemental et culturel est consulté obligatoirement pour toute grande réforme." },
        { number: 42, id: "article-42", text: "La Chambre nationale des Rois et Chefs traditionnels conseille le gouvernement sur la préservation des coutumes." }
      ]
    },
    {
      id: "titre-11",
      number: "XI",
      title: "Des Dispositions Transitoires et Finales",
      chapters: [],
      articles: [
        { number: 43, id: "article-43", text: "Les dispositions transitoires organisent le passage de la 3ᵉ à la 4ᵉ République." },
        { number: 44, id: "article-44", text: "Les lois organiques nécessaires sont adoptées dans les 12 mois suivant la promulgation." },
        { number: 45, id: "article-45", text: "La présente Constitution entre en vigueur dès son adoption par référendum." }
      ]
    }
  ]
};

export const organicLawsData = [
  {
    id: "loi-1",
    number: 1,
    title: "Organisation Territoriale et Décentralisation",
    articles: [
      { number: 1, id: "loi-1-article-1", text: "La République de Côte d'Ivoire est organisée en collectivités territoriales : provinces, départements, communes et districts." },
      { number: 2, id: "loi-1-article-2", text: "Chaque province est administrée par un gouverneur élu et une assemblée provinciale élue." },
      { number: 3, id: "loi-1-article-3", text: "Les départements sont dirigés par des préfets nommés par les gouverneurs provinciaux." },
      { number: 4, id: "loi-1-article-4", text: "Les communes sont dirigées par des maires et des conseils municipaux élus." },
      { number: 5, id: "loi-1-article-5", text: "Les districts regroupent plusieurs communes pour coordonner des politiques métropolitaines." },
      { number: 6, id: "loi-1-article-6", text: "Un fonds de péréquation national est institué." },
      { number: 7, id: "loi-1-article-7", text: "La gestion des collectivités territoriales est soumise à un audit annuel de la Cour des comptes." }
    ]
  },
  {
    id: "loi-2",
    number: 2,
    title: "Fonds de Péréquation",
    articles: [
      { number: 1, id: "loi-2-article-1", text: "Le fonds de péréquation est alimenté par une quote-part des recettes fiscales nationales." },
      { number: 2, id: "loi-2-article-2", text: "Il est administré par une commission indépendante." },
      { number: 3, id: "loi-2-article-3", text: "Les ressources sont affectées prioritairement aux provinces défavorisées." }
    ]
  },
  {
    id: "loi-3",
    number: 3,
    title: "Référendum d'Initiative Populaire",
    articles: [
      { number: 1, id: "loi-3-article-1", text: "Un référendum peut être organisé si une pétition recueille au moins 10 % des signatures des électeurs." },
      { number: 2, id: "loi-3-article-2", text: "Les signatures doivent être validées par la CEI dans un délai de trois mois." },
      { number: 3, id: "loi-3-article-3", text: "La question posée doit être validée par le Conseil constitutionnel." },
      { number: 4, id: "loi-3-article-4", text: "Le résultat s'impose à toutes les autorités." }
    ]
  },
  {
    id: "loi-4",
    number: 4,
    title: "Pétitions Citoyennes",
    articles: [
      { number: 1, id: "loi-4-article-1", text: "Toute pétition citoyenne déposée par au moins 50 000 citoyens doit être examinée par le Parlement dans un délai de trois mois." },
      { number: 2, id: "loi-4-article-2", text: "Les débats liés à la pétition sont publics et retransmis." },
      { number: 3, id: "loi-4-article-3", text: "La réponse doit être motivée et publiée au Journal officiel." }
    ]
  },
  {
    id: "loi-5",
    number: 5,
    title: "Commission Électorale Indépendante (CEI)",
    articles: [
      { number: 1, id: "loi-5-article-1", text: "La CEI est une institution indépendante chargée d'organiser et de superviser les élections." },
      { number: 2, id: "loi-5-article-2", text: "Ses membres sont désignés par le Conseil supérieur de la magistrature, les universités et la société civile." },
      { number: 3, id: "loi-5-article-3", text: "La CEI dispose d'un budget autonome." },
      { number: 4, id: "loi-5-article-4", text: "Elle publie un rapport d'activité après chaque scrutin." }
    ]
  },
  {
    id: "loi-6",
    number: 6,
    title: "Conseil Constitutionnel",
    articles: [
      { number: 1, id: "loi-6-article-1", text: "Le Conseil constitutionnel est composé de 9 membres." },
      { number: 2, id: "loi-6-article-2", text: "Les membres sont nommés pour un mandat à vie." },
      { number: 3, id: "loi-6-article-3", text: "Tout citoyen peut saisir le Conseil constitutionnel par un recours accéléré." }
    ]
  },
  {
    id: "loi-7",
    number: 7,
    title: "Conseil Supérieur de la Magistrature",
    articles: [
      { number: 1, id: "loi-7-article-1", text: "Le Conseil supérieur de la magistrature veille à l'indépendance des juges." },
      { number: 2, id: "loi-7-article-2", text: "Il statue sur les nominations, promotions et sanctions disciplinaires." },
      { number: 3, id: "loi-7-article-3", text: "Les magistrats bénéficient d'une protection contre toute mutation arbitraire." }
    ]
  },
  {
    id: "loi-8",
    number: 8,
    title: "Juridictions Provinciales",
    articles: [
      { number: 1, id: "loi-8-article-1", text: "Chaque province dispose d'un tribunal de première instance." },
      { number: 2, id: "loi-8-article-2", text: "Les procédures devant ces tribunaux sont simplifiées." },
      { number: 3, id: "loi-8-article-3", text: "Des juges de proximité sont institués dans les zones rurales." }
    ]
  },
  {
    id: "loi-9",
    number: 9,
    title: "Cour des Comptes",
    articles: [
      { number: 1, id: "loi-9-article-1", text: "La Cour des comptes contrôle la régularité et la sincérité des finances publiques." },
      { number: 2, id: "loi-9-article-2", text: "Elle publie ses rapports annuellement." },
      { number: 3, id: "loi-9-article-3", text: "Tout citoyen ou parlementaire peut la saisir." }
    ]
  },
  {
    id: "loi-10",
    number: 10,
    title: "Système Éducatif",
    articles: [
      { number: 1, id: "loi-10-article-1", text: "Le calendrier scolaire est fixé en fonction des deux saisons climatiques." },
      { number: 2, id: "loi-10-article-2", text: "Les programmes scolaires incluent : éducation civique, sensibilisation environnementale, projets entrepreneuriaux et initiation aux nouvelles technologies." },
      { number: 3, id: "loi-10-article-3", text: "L'État finance la formation continue des enseignants." }
    ]
  },
  {
    id: "loi-11",
    number: 11,
    title: "Maisons des Opportunités",
    articles: [
      { number: 1, id: "loi-11-article-1", text: "Les maisons des opportunités sont implantées dans chaque province." },
      { number: 2, id: "loi-11-article-2", text: "Elles offrent formation numérique, accès aux services en ligne et soutien aux projets des jeunes." },
      { number: 3, id: "loi-11-article-3", text: "Elles sont dirigées par des formateurs experts recrutés sur concours." }
    ]
  },
  {
    id: "loi-12",
    number: 12,
    title: "Conseil Économique, Social, Environnemental et Culturel",
    articles: [
      { number: 1, id: "loi-12-article-1", text: "Ce Conseil est obligatoirement consulté pour toute réforme économique, sociale ou environnementale." },
      { number: 2, id: "loi-12-article-2", text: "Ses avis sont publics et publiés au Journal officiel." },
      { number: 3, id: "loi-12-article-3", text: "Il produit un rapport annuel." }
    ]
  },
  {
    id: "loi-13",
    number: 13,
    title: "Chambre Nationale des Rois et Chefs Traditionnels",
    articles: [
      { number: 1, id: "loi-13-article-1", text: "La Chambre nationale des Rois et Chefs traditionnels conseille le gouvernement." },
      { number: 2, id: "loi-13-article-2", text: "Elle est composée de représentants élus parmi les autorités coutumières." },
      { number: 3, id: "loi-13-article-3", text: "Ses avis sont consultatifs mais obligatoirement pris en compte." }
    ]
  },
  {
    id: "loi-14",
    number: 14,
    title: "Sur l'Élection Présidentielle et les Scrutins",
    chapters: [
      {
        id: "loi-14-chapitre-1",
        number: "I",
        title: "Conditions de candidature",
        articles: [
          { number: 1, id: "loi-14-article-1", text: "Tout électeur né ivoirien inscrit sur les listes électorales peut être candidat à l'élection présidentielle." },
          { number: 2, id: "loi-14-article-2", text: "Le candidat doit jouir de l'intégralité de ses droits civiques et politiques." },
          { number: 3, id: "loi-14-article-3", text: "Aucun autre critère ou condition ne peut être opposé à un citoyen ivoirien pour restreindre sa candidature." },
          { number: 4, id: "loi-14-article-4", text: "Les candidatures sont accompagnées d'un dossier administratif comprenant : une déclaration sur l'honneur de jouissance des droits civiques et le reçu de dépôt de la caution électorale fixée par décret." },
          { number: 5, id: "loi-14-article-5", text: "Le montant de la caution électorale est fixé à un niveau raisonnable afin de garantir la sincérité des candidatures, sans restreindre l'éligibilité." }
        ]
      },
      {
        id: "loi-14-chapitre-2",
        number: "II",
        title: "Ticket présidentiel et mode de scrutin",
        articles: [
          { number: 6, id: "loi-14-article-6", text: "L'élection présidentielle se fait au scrutin de liste : chaque candidature comprend un binôme composé d'un candidat à la présidence et d'un candidat à la vice-présidence." },
          { number: 7, id: "loi-14-article-7", text: "Le binôme présidentiel est indivisible. Le retrait, la disqualification ou le décès de l'un des deux candidats entraîne le retrait de la liste entière." },
          { number: 8, id: "loi-14-article-8", text: "Le bulletin de vote mentionne les noms du candidat à la présidence et de son colistier à la vice-présidence." },
          { number: 9, id: "loi-14-article-9", text: "Le Président et le Vice-Président sont élus au suffrage universel direct, au scrutin uninominal majoritaire à deux tours." },
          { number: 10, id: "loi-14-article-10", text: "Est déclaré élu au premier tour le binôme ayant obtenu la majorité absolue des suffrages exprimés." },
          { number: 11, id: "loi-14-article-11", text: "Si aucun binôme n'obtient la majorité absolue, un second tour est organisé dans un délai de 21 jours entre les deux binômes arrivés en tête." },
          { number: 12, id: "loi-14-article-12", text: "Est déclaré élu au second tour le binôme ayant obtenu la majorité simple des suffrages exprimés." }
        ]
      },
      {
        id: "loi-14-chapitre-3",
        number: "III",
        title: "Répartition des pouvoirs et suppléance",
        articles: [
          { number: 13, id: "loi-14-article-13", text: "Le Vice-Président, élu avec le Président, est investi de pouvoirs publics élargis définis par la Constitution, en particulier la gestion des administrations territoriales, le suivi des collectivités locales et la mise en œuvre des politiques de décentralisation." },
          { number: 14, id: "loi-14-article-14", text: "Le Vice-Président est le suppléant constitutionnel du Président en cas de vacance, d'incapacité ou de décès." },
          { number: 15, id: "loi-14-article-15", text: "Le mandat du Président est renouvelable sans limitation. Les modalités de suppléance et de continuité de l'État sont précisées par la Constitution." }
        ]
      },
      {
        id: "loi-14-chapitre-4",
        number: "IV",
        title: "Déroulement de la campagne",
        articles: [
          { number: 16, id: "loi-14-article-16", text: "La campagne électorale débute 30 jours avant le scrutin et prend fin 48 heures avant le jour du vote." },
          { number: 17, id: "loi-14-article-17", text: "L'égalité de traitement des candidats dans les médias publics est garantie par la CEI." },
          { number: 18, id: "loi-14-article-18", text: "Le financement public de la campagne est prévu. Les candidats peuvent recourir à des financements privés déclarés, dans la limite des plafonds fixés par décret." }
        ]
      },
      {
        id: "loi-14-chapitre-5",
        number: "V",
        title: "Proclamation et contentieux électoral",
        articles: [
          { number: 19, id: "loi-14-article-19", text: "La CEI proclame les résultats provisoires." },
          { number: 20, id: "loi-14-article-20", text: "Les résultats définitifs sont proclamés par le Conseil constitutionnel après examen des éventuels recours." },
          { number: 21, id: "loi-14-article-21", text: "Tout candidat ou électeur inscrit peut contester le scrutin devant le Conseil constitutionnel dans un délai de 5 jours après la proclamation provisoire." },
          { number: 22, id: "loi-14-article-22", text: "Le Conseil constitutionnel statue dans un délai de 10 jours. Sa décision est définitive." }
        ]
      },
      {
        id: "loi-14-chapitre-6",
        number: "VI",
        title: "Dispositions financières et transparence",
        articles: [
          { number: 23, id: "loi-14-article-23", text: "Chaque binôme dépose un rapport financier de campagne auprès de la Cour des comptes dans un délai de 30 jours après le scrutin." },
          { number: 24, id: "loi-14-article-24", text: "Les rapports financiers sont rendus publics." },
          { number: 25, id: "loi-14-article-25", text: "Toute fraude ou dissimulation financière entraîne des sanctions pouvant aller jusqu'à l'inéligibilité." }
        ]
      },
      {
        id: "loi-14-chapitre-7",
        number: "VII",
        title: "Dispositions finales",
        articles: [
          { number: 26, id: "loi-14-article-26", text: "La présente loi organique s'applique à l'élection présidentielle ainsi qu'aux élections législatives, locales et référendums, sauf dispositions spécifiques prévues par d'autres lois." },
          { number: 27, id: "loi-14-article-27", text: "La présente loi organique entre en vigueur dès sa promulgation et son adoption par le Parlement." }
        ]
      }
    ],
    articles: []
  }
];
